import request from '@/utils/request'
//getTrainingVideo
export function getTrainingVideo(data) {
  return request({
    url: '/getTrainingVideo',
    method: 'post',
    data
  })
}
//addTrainingVideo
export function addTrainingVideo(data) {
  return request({
    url: '/addTrainingVideo',
    method: 'post',
    data
  })
}
//delTrainingVideo
export function delTrainingVideo(data) {
  return request({
    url: '/delTrainingVideo',
    method: 'post',
    data
  })
}
//updateTrainingVideo
export function updateTrainingVideo(data) {
  return request({
    url: '/updateTrainingVideo',
    method: 'post',
    data
  })
}
//获取列表
export function getQuestionnaire(data) {
  return request({
    url: '/getQuestionnaire',
    method: 'post',
    data
  })
}
//addQuestionnaire
export function addQuestionnaire(data) {
  return request({
    url: '/addQuestionnaire',
    method: 'post',
    data
  })
}
//updateQuestionnaire
export function updateQuestionnaire(data) {
  return request({
    url: '/updateQuestionnaire',
    method: 'post',
    data
  })
}
//updateQuestionnaireDetail
export function updateQuestionnaireDetail(data) {
  return request({
    url: '/updateQuestionnaireDetail',
    method: 'post',
    data
  })
}
//delQuestionnaireDetail
export function delQuestionnaireDetail(data) {
  return request({
    url: '/delQuestionnaireDetail',
    method: 'post',
    data
  })
}

//getQueDetailList
export function getQueDetailList(data) {
  return request({
    url: '/getQueDetailList',
    method: 'post',
    data
  })
}
//addQuestionnaireDetail
export function addQuestionnaireDetail(data) {
  return request({
    url: '/addQuestionnaireDetail',
    method: 'post',
    data
  })
}
//UploadExamTemplate
export function UploadExamTemplate(data) {
  return request({
    url: '/UploadExamTemplate',
    method: 'post',
    data
  })
}
//updateQuestionnaireSwitch
export function updateQuestionnaireSwitch(data) {
  return request({
    url: '/updateQuestionnaireSwitch',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/wenjuan.js